import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import GreenBulletIcon from '../../../assets/icons/greenBullet.png';
import { useStyles, StyledTableCell, StyledTableRow } from './OverviewStyle';

export default function Overview({ headings, data }) {
    const classes = useStyles();

    return (
        <>
            <TableContainer component={Paper} className={classes.eventContainer} >
                <Table className={classes.table} size="medium" aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            {
                                headings.map((item) => {
                                    return (
                                        <StyledTableCell >{item}</StyledTableCell>
                                    )
                                })
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((item) => (
                            <StyledTableRow >
                                <StyledTableCell >{item?.period ? item?.period : item?.credits}</StyledTableCell>
                                <StyledTableCell >{item?.billingGroup ? item?.billingGroup : item?.creditType}</StyledTableCell>
                                <StyledTableCell><div className={classes.butlletIconAndStateRow}>{item?.state && <img className={classes.bulletIcon} src={GreenBulletIcon} />}{item?.state ? item?.state : item?.credit}</div></StyledTableCell>
                                <StyledTableCell >{item?.amount ? item?.amount : item?.remainingCredit}</StyledTableCell>
                                <StyledTableCell >{item?.tax ? item?.tax : item?.creditStartDate}</StyledTableCell>
                                <StyledTableCell >{item?.total ? item?.total : item?.creditExpiryDate}</StyledTableCell>
                                {
                                    item?.eyeIcon &&
                                    <StyledTableCell ><div className={classes.iconsContainerRow}><img className={classes.eyeIcon} src={item?.eyeIcon} /><img width={2} height={15} src={item?.verticalDivider} /><img className={classes.uploadIcon} src={item?.uploadIcon} /></div></StyledTableCell>
                                }
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>

    );
}
